import React from 'react';
import { Link } from 'react-router-dom';

import { BrandLockup } from '../brand/Brand';
import { TAGLINE } from '../../config/brand';
import { footerLinks } from '../../config/publicSite';

/**
 * The public pages' footer (KPE-008): the lockup and tagline, and the site's
 * links in one fixed order — Contact, Terms, Privacy, Consumer health data,
 * Status, Docs — each only once its page is published (src/config/publicSite.js
 * says why, and which item turns each one on).
 *
 * The same footer closes every public page: the landing page, the legal
 * pages, a share link and a public form. Quiet by design: muted links at the
 * 44px touch floor, nothing that competes with the page above it.
 */
export default function PublicFooter() {
	const links = footerLinks();

	return (
		<footer className="public-footer">
			<div className="public-footer__inner">
				<div className="public-footer__brand">
					<BrandLockup markSize={16} wordmarkSize={15} />
					<span className="public-footer__tagline">{TAGLINE}</span>
				</div>
				{links.length ? (
					<nav aria-label="Footer">
						<ul className="public-footer__links">
							{links.map(link => (
								<li key={link.key}><Link to={link.path}>{link.label}</Link></li>
							))}
						</ul>
					</nav>
				) : null}
			</div>
		</footer>
	);
}
